//
//
//
//
//
//
//
//
//
//
//
//



export default {
  name: 'MainShowMoreBtn',

  props: {
    swapedBtnToLink: {
      type: Boolean,
      default: false
    },
    to: {
      type: [Object, String],
      default: () => { name: 'art' }
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['add-more'],

  data() {
    return {

    }
  },

  methods: {
    addMore() {
      this.$emit('add-more')
    }
  }
}
